import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private ngZone: NgZone,
    private translateService: TranslateService
  ) {}

  handleError(error: any) {
    this.ngZone.run(() => {
      console.error('Global Error Handler:', { msg: error?.message, error });
      const _errorMessage = this.translateService.instant(
        error?.message || error?.statusText || 'UNKNOWN_ERROR'
      );
      console.error({ _errorMessage });
      this.injector.get(ToastrService).error(_errorMessage);
    });

    console.error({ error });
  }
}
